import { compose } from 'redux'

import withErrorBoundary from 'components/shared/withErrorBoundary'
import withQueryResults from 'components/shared/withQueryResults'
import withPathname from 'components/shared/withPathname'
import withRedux from './withRedux'
import withQuery from './withQuery'
import withFormResults from 'components/shared/withFormResults'
import withAppSettings from 'components/shared/withAppSettings'
import withMutation from './withMutation'
import withState from './withState'
import withEventHandlers from './withEventHandlers'

// presentational component
import UI from './UI'

const withCreateAccountFormResults = withFormResults({
  mutation: 'createAccount',
  field: 'account',
  successMessage: 'Account created!',
  onSuccess: data => {
    window.dataLayer &&
      window.dataLayer.push({ event: 'register.createAccount' })
    window.location.pathname = '/register/parents'
  }
})

export default compose(
  withPathname, // for bottom nav button
  withAppSettings,
  withErrorBoundary,
  withRedux,
  withQueryResults,
  withQuery,
  withCreateAccountFormResults,
  withMutation,
  withState,
  withEventHandlers
)(UI)
